import React, { Component, useEffect, useRef, useState } from "react";
import apiInstance from "../apiInstance";
import { formatDate } from "../Functions/formatDate";
import PopupModal from "./popups/PopupModal";

class DeavadminPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payments: [],
      filteredPayments: [],
      users: [],
      widgetNameSearch: "",
      error: "",
      popupModal: React.createRef(),
      selectedCustomer: "",
      selectedStatus: "",
      minAmount: "",
      maxAmount: "",
      dateFilter: "all",
      startDate: "",
      endDate: "",
      showCustomDatePicker: false,
    };
  }

  componentDidMount() {
    this.fetchPayments();
    this.fetchUsers();
  }

  fetchPayments = () => {
    const request_body = { collectionName: "payments" };

    apiInstance
      .post("/devadmin/collection", request_body)
      .then((response) => {
        const payments = response.data.documents;
        this.setState({
          payments: payments,
          filteredPayments: payments,
        });
      })
      .catch((error) => {
        console.error("Error fetching payments:", error);
      });
  };

  fetchUsers = () => {
    apiInstance
      .get("/devadmin/user")
      .then((response) => {
        const users = response.data.users || [];
        this.setState({
          users: users,
        });
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };

  addPayment = (newPayment) => {
    this.setState((prevState) => {
      const updatedPayments = [newPayment, ...prevState.payments];
      return {
        payments: updatedPayments,
        filteredPayments: this.applyFilters(updatedPayments),
      };
    });
  };

  handleCustomerChange = (e) => {
    this.setState({ selectedCustomer: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };
  handleWidgetNameSearchChange = (e) => {
    this.setState({ widgetNameSearch: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };
  handleStatusChange = (e) => {
    this.setState({ selectedStatus: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };

  handleMinAmountChange = (e) => {
    this.setState({ minAmount: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };

  handleMaxAmountChange = (e) => {
    this.setState({ maxAmount: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };

  handleDateFilterChange = (e) => {
    const value = e.target.value;
    const showCustomDatePicker = value === "custom";

    let startDate = "";
    let endDate = "";

    if (value === "today") {
      const today = new Date();
      startDate = today.toISOString().split("T")[0];
      endDate = today.toISOString().split("T")[0];
    } else if (value === "last7days") {
      const today = new Date();
      const lastWeek = new Date();
      lastWeek.setDate(today.getDate() - 7);
      startDate = lastWeek.toISOString().split("T")[0];
      endDate = today.toISOString().split("T")[0];
    } else if (value === "thismonth") {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      startDate = firstDay.toISOString().split("T")[0];
      endDate = today.toISOString().split("T")[0];
    }

    this.setState(
      {
        dateFilter: value,
        showCustomDatePicker,
        startDate,
        endDate,
      },
      () => {
        this.applyFiltersToState();
      }
    );
  };

  handleStartDateChange = (e) => {
    this.setState({ startDate: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };

  handleEndDateChange = (e) => {
    this.setState({ endDate: e.target.value }, () => {
      this.applyFiltersToState();
    });
  };

  applyFiltersToState = () => {
    const filteredPayments = this.applyFilters(this.state.payments);
    this.setState({ filteredPayments });
  };

  applyFilters = (payments) => {
    const {
      selectedCustomer,
      selectedStatus,
      minAmount,
      maxAmount,
      dateFilter,
      startDate,
      widgetNameSearch,
      endDate,
    } = this.state;

    return payments.filter((payment) => {
      // Customer filter
      if (selectedCustomer && payment.userId !== selectedCustomer) {
        return false;
      }

      // Widget name search filter
      if (widgetNameSearch) {
        if (!payment.widgetName) {
          return false;
        }
        if (!payment.widgetName.toLowerCase().includes(widgetNameSearch.toLowerCase())) {
          return false;
        }
      }

      // Status filter
      if (selectedStatus) {
        const status = !payment.status ? "paid" : payment.status;
        if (status !== selectedStatus) {
          return false;
        }
      }

      // Amount filter
      if (minAmount && payment.amount < parseFloat(minAmount)) {
        return false;
      }

      if (maxAmount && payment.amount > parseFloat(maxAmount)) {
        return false;
      }

      // Date filter
      if (
        dateFilter === "custom" ||
        dateFilter === "today" ||
        dateFilter === "last7days" ||
        dateFilter === "thismonth"
      ) {
        const paymentDate = new Date(payment.created * 1000);

        if (startDate) {
          const filterStartDate = new Date(startDate);
          if (paymentDate < filterStartDate) {
            return false;
          }
        }

        if (endDate) {
          const filterEndDate = new Date(endDate);
          filterEndDate.setHours(23, 59, 59, 999);
          if (paymentDate > filterEndDate) {
            return false;
          }
        }
      }

      return true;
    });
  };
  render() {
    const {
      filteredPayments,
      users,
      selectedCustomer,
      selectedStatus,
      minAmount,
      maxAmount,
      dateFilter,
      showCustomDatePicker,
      startDate,
      endDate,
    } = this.state;

    return (
      <div className="mjwidev-main">
        <div className="mjwidev-main-top">
          <h2>Payment History</h2>
          <div
            className="mjwidev-add-user-btn mjwi-btn mjwidev-addnew"
            onClick={() =>
              this.state.popupModal.current.openPopup("addPayment")
            }
          >
            Add New Payment
          </div>
        </div>

        {/* Filter Section */}
        <div className="mjwidev-filter-wrapper">
          {/* Widget Name Search Input */}
          <div className="mjwidev-input-field">
            <input
              type="text"
              placeholder="Search Widget Name"
              value={this.state.widgetNameSearch}
              onChange={this.handleWidgetNameSearchChange}
            />
          </div>

          {/* Customer Dropdown */}
          <div className="mjwidev-input-field custom-select-wrapper mjwidev-width-40">
            <select
              value={selectedCustomer}
              onChange={this.handleCustomerChange}
            >
              <option value="">All Customers</option>
              {users.map((user) => (
                <option key={user._id || user.id} value={user._id || user.id}>
                  {user.displayName || user.email || "Unknown User"}
                </option>
              ))}
            </select>
            <div className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 
                  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 
                  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                ></path>
              </svg>
            </div>
          </div>
          {/* Status Dropdown */}
          <div className="mjwidev-input-field custom-select-wrapper mjwidev-width-40">
            <select value={selectedStatus} onChange={this.handleStatusChange}>
              <option value="">All Statuses</option>
              <option value="paid">Paid</option>
              <option value="open">Failed</option>
            </select>
            <div   className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 
                  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 
                  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                ></path>
              </svg>
            </div>
          </div>

          {/* Date Filter Dropdown */}
          <div className="mjwidev-input-field custom-select-wrapper mjwidev-width-40">
            <select value={dateFilter} onChange={this.handleDateFilterChange}>
              <option value="all">All Dates</option>
              <option value="today">Today</option>
              <option value="last7days">Last 7 Days</option>
              <option value="thismonth">This Month</option>
              <option value="custom">Custom</option>
            </select>
            <div   className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 
                  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 
                  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div className="mjwidev-filter-wrapper">
            {/* Min Amount */}
            <div className="mjwidev-input-field">
              <input
                type="number"
                placeholder="Min Amount"
                value={minAmount}
                onChange={this.handleMinAmountChange}
              />
            </div>

            {/* Max Amount */}
            <div className="mjwidev-input-field">
              <input
                type="number"
                placeholder="Max Amount"
                value={maxAmount}
                onChange={this.handleMaxAmountChange}
              />
            </div>

            {/* Custom Date Range Pickers */}
            {showCustomDatePicker && (
              <>
                <div className="mjwidev-input-field">
                  <input
                    type="date"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={this.handleStartDateChange}
                  />
                </div>
                <div className="mjwidev-input-field">
                  <input
                    type="date"
                    placeholder="End Date"
                    value={endDate}
                    onChange={this.handleEndDateChange}
                  />
                </div>
              </>
            )}
          </div>

        <PaymentTable payments={filteredPayments} />
        <PopupModal ref={this.state.popupModal} addPayment={this.addPayment} />
      </div>
    );
  }
}
export default DeavadminPayments;

export const PaymentTable = ({ payments, styleSubscription = null }) => {

  const [newPayments, setNewPayments] = useState(payments);
  const popupRef = useRef(null);

  useEffect(() => {
    setNewPayments(payments);
  }, [payments]);

  function formatPrice(amount) {
    if (!amount) return;
    return `$${amount.toFixed(2)}`;
  }

  function getPaymentStatus(payment) {
    if (!payment.status) {
      return "paid";
    } else if (payment.status === "paid") {
      return "paid";
    } else {
      return "failed";
    }
  }

  const deletePayment = async (paymentId) => {
    setNewPayments((prevPayments) =>
      prevPayments.filter(
        (payment) =>
          payment._id !== paymentId && payment.id !== paymentId
      )
    );
  };

  return (
    <div
      style={styleSubscription ? { height: styleSubscription } : undefined}
      className="mjwi-setting-page mjwi-subscription-page"
    >
      <table className="mjwidev-table " border="1">
        <thead>
          <tr>
            <th></th>
            <th>Customer</th>
            <th>Widget</th>
            <th>Amount</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {newPayments.length > 0 ? (
            newPayments.map((item, index) => (
              <tr className="mjwi-subscription-table-row" key={index}>
                <td></td>
                <td>{item.userName || "-"}</td>
                <td>{item.widgetName || "-"}</td>
                <td>{formatPrice(item.amount)}</td>
                <td>{item?.methodDetail || '-'}</td>
                <td>{getPaymentStatus(item)}</td>
                <td>{formatDate(item.created)}</td>
                <td className="mjwidev-act-btns">
                    <i 
                        className="fa-solid fa-trash"
                        onClick={(e) => {
                            e.stopPropagation();
                            popupRef.current.openPopup(
                                "deletePayment",
                                { paymentId: item.id || item._id }
                            );
                        }}
                    ></i>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <PopupModal
        ref={popupRef}
        deletePayment={deletePayment}
      />
    </div>
  );
};
